import BaseLayout from '@/layouts/BaseLayout'

export default [
  {
    name: 'starTab',
    path: '/star',
    component: BaseLayout,
    meta: {
      title: '星级服务'
    },
    children: [
      {
        name: 'star',
        path: '/star',
        component: () => import('_p/star'),
        meta: {
          title: '星级服务',
          titleBold: true,
          noBg: true
        }
      },
      {
        name: 'starList',
        path: '/star/list/:id',
        component: () => import('_p/star/list'),
        beforeEnter(to, from, next) {
          to.meta.title = to.query?.name ? to.query?.name : '星级服务列表'
          next()
        },
        meta: {
          title: '自助查询分类',
          titleBold: true,
          noBg: false
        }
      },
      {
        name: 'starDetail',
        path: '/star/detail/:id',
        component: () => import('_p/star/detail'),
        meta: {
          title: '内容详情',
          trackTitle: '查询详情页面',
          titleBold: true,
          noBg: false
        }
      }
    ]
  }
]
